import Model from '../orm/Model'
import Input from '../orm/Input'
import Student from './Student'
import StudentTravel from './StudentTravel'

export default class Travel extends Model {
    
    static entity = 'travel'

    static fields() {
        return {
            id: this.attr(null),
            team_id: this.attr(null),
            start_date: this.attr(new Date().setHours(6, 0)),
            end_date: this.attr(new Date().setHours(20, 0)),
            notes: this.attr(''),
            is_away: this.attr(null),
            students_count: this.attr(null),
            students: this.belongsToMany(
                Student,
                StudentTravel,
                'travel_id',
                'student_id'
            ),
        }
    }

    static graphql = {
        all: {
            type: 'travel',
            paginated: true,
            parameters: {
                team_id: 'Int!',
                page: 'Int!',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String'
            },
            include: [ 'students' ]
        },
        create: {
            type: 'createTravel',
            parameters: {
                input: new Input('TravelInput!', [
                    'team_id',
                    'start_date',
                    'end_date',
                    'students',
                    'is_away',
                    'notes'
                ])
            }
        },
        update: {
            type: 'updateTravel',
            parameters: {
                id: 'Int!',
                input: new Input('TravelInput!', [
                    'team_id',
                    'start_date',
                    'end_date',
                    'students',
                    'is_away',
                    'notes'
                ])
            },
            include: [ 'students' ]
        },
        remove: {
            type: 'removeTravel',
            parameters: {
                id: 'Int!'
            }
        }
    }
}